import React from "react";

interface CustomSelectProps {
  options: string[];
  value: string;
  onChange: (value: string) => void;
  width: string;
}

export default function CustomSelect({
  options,
  value,
  onChange,
  width
}: CustomSelectProps) {
  return (
    <div
      className={`relative text-zinc-800 text-sm font-normal border border-zinc-300 rounded-lg ${width}`}
    >
      <select
        className="w-full text-sm font-normal bg-white rounded-lg border-none px-4 py-2 pr-9 appearance-none focus:outline-none focus:ring-0"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option || ""}
          </option>
        ))}
      </select>
      <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none flex items-center text-zinc-400">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    </div>
  );
}
